<template>
    <div>
        <portal to="breadcrumb-name">{{$t('message.change_deice')}} {{name}}</portal>   
        <cardWrapper>
            <form v-if="device_id">
                <div class="layout-form">
                    <div :class="['form-group', 'mb-50', {error : validation.firstError('name')}]">
                            <div class="controls">
                                <label>{{ $t("message.name") }}</label>
                                <input type="text" @change="save" class="form-control" v-model="name"/>
                                <div class="help-block">{{ validation.firstError('name') }}</div>
                            </div> 
                    </div> 
                    <div :class="['form-group', 'mb-50']">
                        <div class="controls">
                            <label>{{ $t("message.serial_number") }}</label>
                            <input type="text" class="form-control" readonly v-model="serial_number"/>
                        </div> 
                    </div>   
                    <div  v-if="status == '3'" :class="['form-group', 'mb-50']">
                        <div class="controls">
                            <label>{{ $t("message.date_transfer") }}</label>
                            <input type="text" class="form-control" readonly v-model="date_transfer"/>
                        </div> 
                    </div>  
                    <div :class="['form-group', 'mb-50']">
                        <div class="controls">
                            <label>{{ $t("message.status") }}</label>
                            <input type="text" class="form-control" readonly v-model="status_name"/>
                        </div> 
                    </div>
                    <label>{{ $t("message.design") }}</label>
                    <iframe :src="'https://connect.motorica.org/constructor/?token='+token+'&lang='+$i18n.locale+'&tm='+Date.now()" allowtransparency="true" scrolling="no" width="100%" height="600px" frameborder="0"></iframe>             
                    
                    </div>
            </form>
            
        </cardWrapper>

    </div>
</template>

<script>
import globalSettings from '@/config.js'   
import cardWrapper from '@/components/cardWrapper' 
import {devices_statuses} from '@/helpers'
import axios from 'axios'
import Validator from '@/formValidator'
import {error_setter} from '@/formValidator'
export default {   
  name: 'device_form',
    data () {
     return { 
         
        name:null,
        token:null,
        constructor:null,
        serial_number:null,
        settings:null,
        status:null,
        status_name:null,
        date_transfer:null,
     }
    },
    computed: {
        device_id () {
           this.getData(this.$route.params.id)
           return this.$route.params.id
        }
    },
    mixins:[error_setter, devices_statuses],
    validators: {
        'name': function (value) {
            return Validator.value(value).required().minLength(2);
        },
        
    },
    components:{
        cardWrapper,
    },
    
    methods: {
        
       getData: function(id){
          this.loaded = false
            let url  = globalSettings.api_url + 'clients/'+this.$store.state.user_info.client_id+'/device/'+id+'/data'
            axios.post(url)
                .then(response => {
               this.serial_number = response.data.serial_number
               this.settings = response.data.settings
               this.status = response.data.status
               this.token = response.data.token
               this.constructor_name = response.data.constructor
               this.status_name = this.$t('message.'+this.getStatusName(response.data.status))
               if(this.date_transfer){
                    let date = this.response.data.date_transfer.getTime()
                    this.date_transfer = date.getYear()+"-"+date.getMonth()+"-"+date.getDay();
               }
               this.name = response.data.name

            })
            .catch(error => {
               console.log(error)
            })         
      },
      save: function(){
          this.loaded = false
            let data={
                name:this.name,
            }
            if( this.status == '0'){
                 data.settings = this.settings
            }
            let url  = globalSettings.api_url + 'clients/'+this.$store.state.user_info.client_id+'/device/'+this.device_id+'/update'
            axios.post(url, data)
                .then(response => {
                    if(response.data == 'ok'){
                        this.$store.dispatch('set_alert',{type:'success', text:this.$t('message.device_change_success')})
                        this.$store.dispatch('get_devices')
                        this.$router.push({path:'/'})
                        this.reset_form()
                     }else{
                         this.add_external_errors(response.data.errors)
                     } 

            })
            .catch(error => {
               console.log(error)
            })         
      },
      order: function(){
            
            if(this.$store.getters.isRequirements){
                 return;
            }
            
            if(this.status !='0'){
                return
            }
            let data={
                device_id:this.device_id,
            }
            let url  = globalSettings.api_url + 'clients/'+this.$store.state.user_info.client_id+'/device/'+this.device_id+'/order-create'
            axios.post(url, data)
            .then(response => {
                if(response.data == 'ok'){
                   this.$store.dispatch('set_alert',{type:'success', text:this.$t('message.order_create')})
                   this.$store.dispatch('get_devices')  
                   this.$router.push({path:'/'})
                }else{
                   this.$store.dispatch('set_alert',{type:'danger', text:this.$t('message.send_exception')})  
                }
            })
            .catch(error => {
               console.log(error)
            })         
      },
    }
  
  
}
</script>